import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[100] bg-background flex flex-col"
}
const _hoisted_2 = { class: "h-14 border-b flex items-center justify-between px-4 shrink-0" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = { class: "flex-1 flex min-h-0" }
const _hoisted_6 = { class: "w-64 border-r flex flex-col shrink-0" }
const _hoisted_7 = { class: "p-3 border-b" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "p-2" }
const _hoisted_10 = { class: "text-xs text-muted-foreground px-2 mb-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "font-medium truncate" }
const _hoisted_13 = { class: "text-xs text-muted-foreground truncate" }
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-muted-foreground px-2 py-4 text-center"
}
const _hoisted_15 = { class: "p-2" }
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = { class: "text-xs font-medium text-muted-foreground px-2 mb-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "truncate" }
const _hoisted_20 = { class: "flex-1 min-w-0" }
const _hoisted_21 = { class: "max-w-3xl mx-auto p-6" }
const _hoisted_22 = { class: "bg-gradient-to-br from-primary/10 via-primary/5 to-transparent" }
const _hoisted_23 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" }
const _hoisted_24 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_25 = { class: "h-9 w-9 rounded-lg bg-green-500/10 flex items-center justify-center" }
const _hoisted_26 = { class: "font-semibold" }
const _hoisted_27 = {
  key: 0,
  class: "text-sm text-muted-foreground line-clamp-2"
}
const _hoisted_28 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_29 = { class: "h-9 w-9 rounded-lg bg-blue-500/10 flex items-center justify-center" }
const _hoisted_30 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_31 = { class: "h-9 w-9 rounded-lg bg-purple-500/10 flex items-center justify-center" }
const _hoisted_32 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = { class: "text-sm font-medium" }
const _hoisted_35 = {
  key: 1,
  class: "text-sm text-muted-foreground"
}
const _hoisted_36 = { class: "flex items-center justify-between" }
const _hoisted_37 = { class: "flex items-center gap-4" }
const _hoisted_38 = { class: "h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center" }
const _hoisted_39 = { class: "text-sm text-muted-foreground" }
const _hoisted_40 = { class: "grid grid-cols-2 md:grid-cols-4 gap-3" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center" }
const _hoisted_43 = { class: "text-sm font-medium" }
const _hoisted_44 = { class: "text-2xl font-bold mb-4" }
const _hoisted_45 = { class: "space-y-2" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "flex-1" }
const _hoisted_48 = { class: "font-medium" }
const _hoisted_49 = {
  key: 0,
  class: "text-sm text-muted-foreground mt-0.5"
}
const _hoisted_50 = { class: "mb-4" }
const _hoisted_51 = {
  key: 0,
  class: "flex gap-1 mt-2 flex-wrap"
}
const _hoisted_52 = { class: "prose prose-sm dark:prose-invert max-w-none" }
const _hoisted_53 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_54 = { class: "rounded-lg overflow-hidden border bg-muted" }
const _hoisted_55 = { class: "aspect-video" }
const _hoisted_56 = ["src"]
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "text-xs text-muted-foreground mt-2 flex items-center gap-1" }
const _hoisted_59 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_60 = { class: "rounded-lg border overflow-hidden bg-muted" }
const _hoisted_61 = ["src", "alt"]
const _hoisted_62 = { class: "text-xs text-muted-foreground mt-2 flex items-center gap-1" }
const _hoisted_63 = {
  key: 2,
  class: "mt-6 pt-4 border-t"
}
const _hoisted_64 = { class: "flex flex-wrap gap-2" }
const _hoisted_65 = {
  key: 3,
  class: "mt-8 pt-6 border-t"
}
const _hoisted_66 = { class: "flex flex-wrap gap-2" }
const _hoisted_67 = { class: "mt-8 pt-6 border-t flex justify-between" }
const _hoisted_68 = { key: 1 }

import { computed, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { collection, query, orderBy, limit, getDocs, where } from '@/lib/firestore'
import { db } from '@/config/firebase'
import { getTenantConstraint } from '@/utils/tenantQuery'
import { useHelpCenter } from '@/composables/useHelpCenter'
import { MdPreview } from 'md-editor-v3'
import 'md-editor-v3/lib/preview.css'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Badge } from '@/components/ui/badge'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import { Card, CardContent } from '@/components/ui/card'
import HelpCenterIntro from '@/components/HelpCenterIntro.vue'
import {
  X,
  Minus,
  Search,
  ChevronLeft,
  ChevronRight,
  BookOpen,
  Home,
  Rocket,
  LayoutDashboard,
  Building2,
  FolderKanban,
  ListTodo,
  ClipboardList,
  Layers,
  MessageSquarePlus,
  Ticket,
  PackageCheck,
  Users,
  Calendar,
  Video,
  FileText,
  Receipt,
  ShoppingCart,
  UserCog,
  Settings,
  Bot,
  Shield,
  History,
  MessageCircle,
  Play,
  ExternalLink,
  Sparkles,
  Star,
  TrendingUp,
  Heart,
  Newspaper,
  Library,
} from 'lucide-vue-next'

import ChangelogSection from '@/views/Help/components/ChangelogSection.vue'
import FeedbackSection from '@/views/Help/components/FeedbackSection.vue'
import NewsSection from '@/views/Help/components/NewsSection.vue'
import HelpModulesDrawer from '@/components/HelpModulesDrawer.vue'

import type { HelpGuide, ActionLink } from '@/types/help'


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpCenterPanel',
  setup(__props) {

const router = useRouter()

const {
  state,
  availableModules,
  availableGuides,
  currentModuleGuides,
  currentGuide,
  searchResults,
  close,
  minimize,
  navigateToGuide,
  navigateToModule,
  navigateToChangelog,
  navigateToFeedback,
  navigateToNews,
  setSearchQuery,
  goHome,
  shouldShowIntro,
  markIntroSeen,
} = useHelpCenter()

// Estado del drawer de módulos
const isModulesDrawerOpen = ref(false)

// Control de la intro
const showingIntro = computed(() => state.value.isOpen && shouldShowIntro() && !state.value.isMinimized)

const handleIntroComplete = () => {
  // La intro ya marcó como vista, solo cerramos el estado
}

// Datos para widgets del home
const latestVersion = ref<{ version: string; notes: string; releasedAt: Date } | null>(null)
const feedbackStats = ref<{ total: number; pending: number; resolved: number; avgRating: number; ratingCount: number }>({
  total: 0,
  pending: 0,
  resolved: 0,
  avgRating: 0,
  ratingCount: 0,
})

// Cargar datos al montar
onMounted(async () => {
  // Cargar última versión
  try {
    const tenantConstraint = getTenantConstraint()
    const baseConstraints = tenantConstraint ? [tenantConstraint] : []
    const appsQuery = query(
      collection(db, 'applications'),
      ...baseConstraints,
      orderBy('updatedAt', 'desc'),
      limit(1)
    )
    const snapshot = await getDocs(appsQuery)
    if (!snapshot.empty) {
      const data = snapshot.docs[0].data()
      const versionHistory = data.versionHistory || []
      if (versionHistory.length > 0) {
        const latest = versionHistory.sort(
          (a: { releasedAt?: { toDate?: () => Date } }, b: { releasedAt?: { toDate?: () => Date } }) => {
            const dateA = a.releasedAt?.toDate?.()?.getTime() || 0
            const dateB = b.releasedAt?.toDate?.()?.getTime() || 0
            return dateB - dateA
          }
        )[0]
        latestVersion.value = {
          version: latest.version,
          notes: latest.notes || '',
          releasedAt: latest.releasedAt?.toDate?.() || new Date(),
        }
      }
    }
  } catch (e) {
    console.error('Error loading version:', e)
  }

  // Cargar stats de feedback
  try {
    const feedbackQuery = query(collection(db, 'userFeedback'))
    const feedbackSnap = await getDocs(feedbackQuery)
    const total = feedbackSnap.size
    let pending = 0
    let resolved = 0
    let ratingSum = 0
    let ratingCount = 0
    feedbackSnap.forEach((doc) => {
      const data = doc.data()
      const status = data.status
      if (status === 'new' || status === 'in_progress') pending++
      if (status === 'resolved') resolved++
      // Calcular promedio de ratings
      if (data.type === 'rating' && data.rating) {
        ratingSum += data.rating
        ratingCount++
      }
    })
    feedbackStats.value = {
      total,
      pending,
      resolved,
      avgRating: ratingCount > 0 ? ratingSum / ratingCount : 0,
      ratingCount,
    }
  } catch (e) {
    console.error('Error loading feedback stats:', e)
  }
})

const iconMap: Record<string, unknown> = {
  Rocket,
  LayoutDashboard,
  Building2,
  FolderKanban,
  ListTodo,
  ClipboardList,
  Layers,
  MessageSquarePlus,
  Ticket,
  PackageCheck,
  Users,
  Calendar,
  Video,
  FileText,
  Receipt,
  ShoppingCart,
  UserCog,
  Settings,
  Bot,
  Shield,
}

const getIcon = (iconName: string) => {
  return iconMap[iconName] || FileText
}

// Guías relacionadas
const relatedGuides = computed<HelpGuide[]>(() => {
  if (!currentGuide.value?.relatedGuides) return []
  return currentGuide.value.relatedGuides
    .map((slug) => availableGuides.value.find((g) => g.slug === slug))
    .filter((g): g is HelpGuide => !!g)
})

// Navegación prev/next dentro del módulo
const currentIndex = computed(() => {
  if (!currentGuide.value) return -1
  return currentModuleGuides.value.findIndex((g) => g.slug === currentGuide.value!.slug)
})

const prevGuide = computed(() => {
  if (currentIndex.value <= 0) return null
  return currentModuleGuides.value[currentIndex.value - 1]
})

const nextGuide = computed(() => {
  if (currentIndex.value < 0 || currentIndex.value >= currentModuleGuides.value.length - 1) return null
  return currentModuleGuides.value[currentIndex.value + 1]
})

const handleSearch = (e: Event) => {
  setSearchQuery((e.target as HTMLInputElement).value)
}

const currentModuleTitle = computed(() => {
  if (!state.value.currentModule) return ''
  return availableModules.value.find((m) => m.id === state.value.currentModule)?.title || ''
})

const roleLabels: Record<string, string> = {
  superadmin: 'Super Admin',
  tenant_admin: 'Tenant Admin',
  admin: 'Admin',
  operator: 'Operador',
  client: 'Cliente',
  member: 'Miembro',
}

// Video helpers
const isYouTube = (url: string): boolean => {
  return url.includes('youtube.com') || url.includes('youtu.be')
}

const getYouTubeEmbed = (url: string): string => {
  let videoId = ''
  if (url.includes('youtu.be/')) {
    videoId = url.split('youtu.be/')[1].split('?')[0]
  } else if (url.includes('watch?v=')) {
    videoId = url.split('watch?v=')[1].split('&')[0]
  } else if (url.includes('/embed/')) {
    videoId = url.split('/embed/')[1].split('?')[0]
  }
  return `https://www.youtube.com/embed/${videoId}`
}

// Action link handler
const handleActionLink = (link: ActionLink) => {
  minimize()
  router.push(link.route)
}

// Formato de fecha
const formatDate = (date: Date): string => {
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date)
}

// Check si estamos en una vista que no es home
const isNotHome = computed(() => {
  return state.value.currentModule || state.value.currentGuide ||
         state.value.currentView === 'changelog' || state.value.currentView === 'feedback' ||
         state.value.currentView === 'news'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (showingIntro.value)
      ? (_openBlock(), _createBlock(HelpCenterIntro, {
          key: 0,
          onComplete: handleIntroComplete
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_unref(state).isOpen && !showingIntro.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (isNotHome.value)
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        variant: "outline",
                        size: "sm",
                        class: "gap-2",
                        onClick: _unref(goHome)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Home), { class: "h-4 w-4" }),
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "hidden sm:inline" }, "Inicio", -1))
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(BookOpen), { class: "h-5 w-5 text-primary" }),
                  _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "font-semibold" }, "Centro de Ayuda", -1))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    onClick: _unref(minimize),
                    title: "Minimizar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Minus), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    onClick: _unref(close),
                    title: "Cerrar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(X), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("aside", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_unref(Search), { class: "absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
                      _createVNode(_unref(Input), {
                        "model-value": _unref(state).searchQuery,
                        placeholder: "Buscar...",
                        class: "pl-8 h-9",
                        onInput: handleSearch
                      }, null, 8, ["model-value"])
                    ])
                  ]),
                  (_unref(state).searchQuery)
                    ? (_openBlock(), _createBlock(_unref(ScrollArea), {
                        key: 0,
                        class: "flex-1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(searchResults).length) + " resultado" + _toDisplayString(_unref(searchResults).length !== 1 ? 's' : ''), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchResults), (guide) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: guide.slug,
                                class: "w-full text-left px-2 py-1.5 rounded hover:bg-muted text-sm",
                                onClick: ($event: any) => (_unref(navigateToGuide)(guide.slug))
                              }, [
                                _createElementVNode("p", _hoisted_12, _toDisplayString(guide.title), 1),
                                _createElementVNode("p", _hoisted_13, _toDisplayString(guide.category), 1)
                              ], 8, _hoisted_11))
                            }), 128)),
                            (_unref(searchResults).length === 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_14, " No se encontraron resultados "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_unref(ScrollArea), {
                        key: 1,
                        class: "flex-1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-xs font-medium text-muted-foreground px-2 mb-2" }, "NAVEGACIÓN", -1)),
                            _createElementVNode("button", {
                              class: _normalizeClass(["w-full flex items-center gap-2 px-2 py-2 rounded text-sm", _unref(state).currentView === 'home' && !_unref(state).currentModule ? 'bg-primary/10 text-primary font-medium' : 'hover:bg-muted']),
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(goHome) && _unref(goHome)(...args)))
                            }, [
                              _createVNode(_unref(Home), { class: "h-4 w-4" }),
                              _cache[11] || (_cache[11] = _createElementVNode("span", null, "Inicio", -1))
                            ], 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["w-full flex items-center gap-2 px-2 py-2 rounded text-sm", _unref(state).currentView === 'news' ? 'bg-primary/10 text-primary font-medium' : 'hover:bg-muted']),
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(navigateToNews) && _unref(navigateToNews)(...args)))
                            }, [
                              _createVNode(_unref(Newspaper), { class: "h-4 w-4" }),
                              _cache[12] || (_cache[12] = _createElementVNode("span", null, "Noticias", -1))
                            ], 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["w-full flex items-center gap-2 px-2 py-2 rounded text-sm", _unref(state).currentView === 'changelog' ? 'bg-primary/10 text-primary font-medium' : 'hover:bg-muted']),
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(navigateToChangelog) && _unref(navigateToChangelog)(...args)))
                            }, [
                              _createVNode(_unref(History), { class: "h-4 w-4" }),
                              _cache[13] || (_cache[13] = _createElementVNode("span", null, "Historial de Cambios", -1))
                            ], 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["w-full flex items-center gap-2 px-2 py-2 rounded text-sm", _unref(state).currentView === 'feedback' ? 'bg-primary/10 text-primary font-medium' : 'hover:bg-muted']),
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(navigateToFeedback) && _unref(navigateToFeedback)(...args)))
                            }, [
                              _createVNode(_unref(MessageCircle), { class: "h-4 w-4" }),
                              _cache[14] || (_cache[14] = _createElementVNode("span", null, "Enviar Feedback", -1))
                            ], 2),
                            _createVNode(_unref(Separator), { class: "my-3" }),
                            _createElementVNode("button", {
                              class: _normalizeClass(["w-full flex items-center justify-between px-2 py-2.5 rounded text-sm bg-primary/5 hover:bg-primary/10 border border-primary/20 transition-colors", _unref(state).currentModule ? 'ring-2 ring-primary/30' : '']),
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (isModulesDrawerOpen.value = true))
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_unref(Library), { class: "h-4 w-4 text-primary" }),
                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "font-medium" }, "Explorar Guías", -1))
                              ]),
                              _createVNode(_unref(ChevronRight), { class: "h-4 w-4 text-primary" })
                            ], 2),
                            (_unref(state).currentModule)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_unref(Separator), { class: "my-3" }),
                                  _createElementVNode("p", _hoisted_17, _toDisplayString(currentModuleTitle.value.toUpperCase()), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentModuleGuides), (guide) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: guide.slug,
                                      class: _normalizeClass(["w-full flex items-center gap-2 px-2 py-2 rounded hover:bg-muted text-sm text-left", _unref(state).currentGuide === guide.slug ? 'bg-primary/10 text-primary' : '']),
                                      onClick: ($event: any) => (_unref(navigateToGuide)(guide.slug))
                                    }, [
                                      _createElementVNode("span", _hoisted_19, _toDisplayString(guide.title), 1)
                                    ], 10, _hoisted_18))
                                  }), 128))
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }))
                ]),
                _createElementVNode("main", _hoisted_20, [
                  _createVNode(_unref(ScrollArea), { class: "h-full" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        (_unref(state).currentView === 'changelog')
                          ? (_openBlock(), _createBlock(ChangelogSection, { key: 0 }))
                          : (_unref(state).currentView === 'feedback')
                            ? (_openBlock(), _createBlock(FeedbackSection, { key: 1 }))
                            : (_unref(state).currentView === 'news')
                              ? (_openBlock(), _createBlock(NewsSection, { key: 2 }))
                              : (_unref(state).currentView === 'home' && !_unref(state).currentModule && !_unref(state).currentGuide && !_unref(state).searchQuery)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createVNode(_unref(Card), { class: "mb-6 overflow-hidden" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_22, [
                                          _createVNode(_unref(CardContent), { class: "p-6" }, {
                                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                              _createElementVNode("div", { class: "flex items-start gap-4" }, [
                                                _createElementVNode("div", { class: "h-16 w-16 rounded-2xl overflow-hidden flex-shrink-0 shadow-sm" }, [
                                                  _createElementVNode("img", {
                                                    src: "/img/icons/isotipoblack.svg",
                                                    alt: "Torcaza Projects",
                                                    class: "h-full w-full object-cover"
                                                  })
                                                ]),
                                                _createElementVNode("div", { class: "flex-1" }, [
                                                  _createElementVNode("h2", { class: "text-xl font-bold mb-1" }, "¡Gracias por usar Torcaza Projects!"),
                                                  _createElementVNode("p", { class: "text-muted-foreground text-sm" }, " Tu plataforma integral para gestión de proyectos, CRM y colaboración. Explora las guías para sacar el máximo provecho de cada funcionalidad. ")
                                                ])
                                              ], -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(_unref(Card), {
                                        class: "cursor-pointer hover:border-primary/50 transition-colors",
                                        onClick: _unref(navigateToChangelog)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CardContent), { class: "p-4" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, [
                                                  _createVNode(_unref(TrendingUp), { class: "h-4 w-4 text-green-600" })
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Última actualización", -1)),
                                                  _createElementVNode("p", _hoisted_26, " v" + _toDisplayString(latestVersion.value?.version || '...'), 1)
                                                ])
                                              ]),
                                              (latestVersion.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(latestVersion.value.notes.split('\n')[0] || 'Ver detalles del cambio'), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _createVNode(_unref(Card), {
                                        class: "cursor-pointer hover:border-primary/50 transition-colors",
                                        onClick: _unref(navigateToNews)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CardContent), { class: "p-4" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, [
                                                  _createVNode(_unref(Newspaper), { class: "h-4 w-4 text-blue-600" })
                                                ]),
                                                _cache[19] || (_cache[19] = _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Mantente informado"),
                                                  _createElementVNode("p", { class: "font-semibold" }, "Noticias")
                                                ], -1))
                                              ]),
                                              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-sm text-muted-foreground" }, " Anuncios, tips y novedades de la plataforma. ", -1))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      _createVNode(_unref(Card), {
                                        class: "cursor-pointer hover:border-primary/50 transition-colors",
                                        onClick: _unref(navigateToFeedback)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CardContent), { class: "p-4" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                  _createVNode(_unref(Heart), { class: "h-4 w-4 text-purple-600" })
                                                ]),
                                                _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                                                  _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Tu opinión importa"),
                                                  _createElementVNode("p", { class: "font-semibold" }, "Feedback")
                                                ], -1))
                                              ]),
                                              (feedbackStats.value.ratingCount > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                    _createElementVNode("div", _hoisted_33, [
                                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                                                        return _createVNode(_unref(Star), {
                                                          key: i,
                                                          class: _normalizeClass(["h-3.5 w-3.5", i <= Math.round(feedbackStats.value.avgRating)
                                ? 'text-yellow-400 fill-yellow-400'
                                : 'text-muted-foreground/30'])
                                                        }, null, 8, ["class"])
                                                      }), 64))
                                                    ]),
                                                    _createElementVNode("span", _hoisted_34, _toDisplayString(feedbackStats.value.avgRating.toFixed(1)), 1)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(feedbackStats.value.total) + " sugerencias ", 1))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _createVNode(_unref(Card), {
                                      class: "cursor-pointer hover:border-primary/50 transition-colors mb-6",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (isModulesDrawerOpen.value = true))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(CardContent), { class: "p-6" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_36, [
                                              _createElementVNode("div", _hoisted_37, [
                                                _createElementVNode("div", _hoisted_38, [
                                                  _createVNode(_unref(Library), { class: "h-6 w-6 text-primary" })
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "font-semibold text-lg" }, "Explorar Guías", -1)),
                                                  _createElementVNode("p", _hoisted_39, _toDisplayString(_unref(availableModules).length) + " módulos · " + _toDisplayString(_unref(availableGuides).length) + " guías disponibles ", 1)
                                                ])
                                              ]),
                                              _createVNode(_unref(ChevronRight), { class: "h-5 w-5 text-muted-foreground" })
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "text-lg font-semibold mb-4" }, "Acceso Rápido", -1)),
                                    _createElementVNode("div", _hoisted_40, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableModules).slice(0, 8), (mod) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: mod.id,
                                          class: "flex flex-col items-center gap-2 p-4 border rounded-lg hover:bg-muted hover:border-primary/30 text-center transition-colors",
                                          onClick: ($event: any) => (_unref(navigateToModule)(mod.id))
                                        }, [
                                          _createElementVNode("div", _hoisted_42, [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(getIcon(mod.icon)), { class: "h-5 w-5 text-primary" }))
                                          ]),
                                          _createElementVNode("span", _hoisted_43, _toDisplayString(mod.title), 1)
                                        ], 8, _hoisted_41))
                                      }), 128))
                                    ])
                                  ], 64))
                                : (_unref(state).currentView === 'module' || (_unref(state).currentModule && !_unref(state).currentGuide))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createElementVNode("h2", _hoisted_44, _toDisplayString(currentModuleTitle.value), 1),
                                      _createElementVNode("div", _hoisted_45, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentModuleGuides), (guide) => {
                                          return (_openBlock(), _createElementBlock("button", {
                                            key: guide.slug,
                                            class: "w-full flex items-start gap-3 p-4 border rounded-lg hover:bg-muted text-left",
                                            onClick: ($event: any) => (_unref(navigateToGuide)(guide.slug))
                                          }, [
                                            _createElementVNode("div", _hoisted_47, [
                                              _createElementVNode("p", _hoisted_48, _toDisplayString(guide.title), 1),
                                              (guide.description)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(guide.description), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createVNode(_unref(ChevronRight), { class: "h-5 w-5 text-muted-foreground shrink-0 mt-0.5" })
                                          ], 8, _hoisted_46))
                                        }), 128))
                                      ])
                                    ], 64))
                                  : (_unref(currentGuide))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _createVNode(_unref(Badge), {
                                            variant: "secondary",
                                            class: "mb-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(currentGuide).category), 1)
                                            ]),
                                            _: 1
                                          }),
                                          (_unref(currentGuide).roles)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentGuide).roles, (role) => {
                                                  return (_openBlock(), _createBlock(_unref(Badge), {
                                                    key: role,
                                                    variant: "outline",
                                                    class: "text-xs"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(roleLabels[role] || role), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_52, [
                                          _createVNode(_unref(MdPreview), {
                                            "model-value": _unref(currentGuide).content,
                                            language: "en-US"
                                          }, null, 8, ["model-value"])
                                        ]),
                                        (_unref(currentGuide).videoUrl)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                              _createElementVNode("div", _hoisted_54, [
                                                _createElementVNode("div", _hoisted_55, [
                                                  (isYouTube(_unref(currentGuide).videoUrl))
                                                    ? (_openBlock(), _createElementBlock("iframe", {
                                                        key: 0,
                                                        src: getYouTubeEmbed(_unref(currentGuide).videoUrl),
                                                        class: "w-full h-full",
                                                        frameborder: "0",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                                        allowfullscreen: ""
                                                      }, null, 8, _hoisted_56))
                                                    : (_openBlock(), _createElementBlock("video", {
                                                        key: 1,
                                                        src: _unref(currentGuide).videoUrl,
                                                        controls: "",
                                                        class: "w-full h-full"
                                                      }, null, 8, _hoisted_57))
                                                ])
                                              ]),
                                              _createElementVNode("p", _hoisted_58, [
                                                _createVNode(_unref(Play), { class: "h-3 w-3" }),
                                                _cache[24] || (_cache[24] = _createTextVNode(" Video demostrativo ", -1))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_unref(currentGuide).gifUrl)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                              _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("img", {
                                                  src: _unref(currentGuide).gifUrl,
                                                  alt: _unref(currentGuide).title,
                                                  class: "w-full",
                                                  loading: "lazy"
                                                }, null, 8, _hoisted_61)
                                              ]),
                                              _createElementVNode("p", _hoisted_62, [
                                                _createVNode(_unref(Play), { class: "h-3 w-3" }),
                                                _cache[25] || (_cache[25] = _createTextVNode(" Animación demostrativa ", -1))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_unref(currentGuide).actionLinks?.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                              _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-sm font-medium mb-3" }, "Acciones rápidas", -1)),
                                              _createElementVNode("div", _hoisted_64, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentGuide).actionLinks, (link) => {
                                                  return (_openBlock(), _createBlock(_unref(Button), {
                                                    key: link.route,
                                                    variant: link.variant || 'outline',
                                                    size: "sm",
                                                    onClick: ($event: any) => (handleActionLink(link))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (link.icon)
                                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(getIcon(link.icon)), {
                                                            key: 0,
                                                            class: "h-4 w-4 mr-1.5"
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      _createTextVNode(" " + _toDisplayString(link.label) + " ", 1),
                                                      _createVNode(_unref(ExternalLink), { class: "h-3 w-3 ml-1.5 opacity-50" })
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["variant", "onClick"]))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (relatedGuides.value.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                              _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "text-sm font-medium mb-3" }, "Guías relacionadas", -1)),
                                              _createElementVNode("div", _hoisted_66, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedGuides.value, (related) => {
                                                  return (_openBlock(), _createBlock(_unref(Button), {
                                                    key: related.slug,
                                                    variant: "outline",
                                                    size: "sm",
                                                    onClick: ($event: any) => (_unref(navigateToGuide)(related.slug))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(related.title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_67, [
                                          (prevGuide.value)
                                            ? (_openBlock(), _createBlock(_unref(Button), {
                                                key: 0,
                                                variant: "ghost",
                                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(navigateToGuide)(prevGuide.value.slug)))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(ChevronLeft), { class: "h-4 w-4 mr-1" }),
                                                  _createTextVNode(" " + _toDisplayString(prevGuide.value.title), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_68)),
                                          (nextGuide.value)
                                            ? (_openBlock(), _createBlock(_unref(Button), {
                                                key: 2,
                                                variant: "ghost",
                                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(navigateToGuide)(nextGuide.value.slug)))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(nextGuide.value.title) + " ", 1),
                                                  _createVNode(_unref(ChevronRight), { class: "h-4 w-4 ml-1" })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(HelpModulesDrawer, {
      "is-open": isModulesDrawerOpen.value && _unref(state).isOpen,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (isModulesDrawerOpen.value = false))
    }, null, 8, ["is-open"])
  ]))
}
}

})